<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row">
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
            <label>{{ $t('common_words.farm') }} *</label>
            <br />
            <el-select
              clearable
              @clear="cleanFarm()"
              @change="showCalendar()"
              filterable
              class="select-primary custom-width-select required-farm shadow-sm farm-form"
              v-model="cuttingForm.farm_id"
              size="large"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in farms"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-3" v-if="isShowCalendar">
            <label>{{ $t('common_words.calendar') }}</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select required-calendar shadow-sm"
              size="large"
              v-model="cuttingForm.calendar_sel"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                v-for="(option, index) in calendars"
                class="select-primary"
                :value="option.id"
                :label="option.name"
                :key="index + option.id"
              ></el-option>
            </el-select>
          </div>
          <div class="col-12 col-sm-12 col-md-6 col-lg-4 mb-3">
            <br class="media-none" />
            <label>{{ $t('common_words.date') }}</label>
            <br />
            <el-date-picker
              v-if="renderComponent"
              :picker-options="pickerOptions"
              class="shadow-sm required-date date-form"
              v-model="cuttingForm.date_sel"
              type="date"
              range-separator="-"
              :placeholder="`${$t('common_words.select2')}...`"
            >
            </el-date-picker>
          </div>
          <div class="col-12 col-md-8 col-lg-12 col-xl-4">
            <div class="row custom-mt-30">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-5 mb-2">
                <l-button
                  wide
                  type="info"
                  class="btn-filter"
                  @click="validate"
                  style="width: inherit"
                >
                  {{ $t('common_words.generate') }}
                </l-button>
              </div>
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-5 mb-2">
                <button
                  class="btn btn-info btn-fg w-100"
                  @click.prevent="preload"
                  style="width: inherit"
                >
                  <i class="fa fa-table"></i> {{ $t('common_words.preload') }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <br />
      </card>
      <card class="custom-shadow-card-header" v-if="showPreload">
        <form>
          <div class="row">
            <div class="col-12">
              <div class="text-center">
                <div class="form-group has-label">
                  <el-upload
                    drag
                    ref="upload"
                    :action="getAxiosURL() + '/auth/cutting/cuts/preload'"
                    :data="{
                      farm_id: cuttingForm.farm_id,
                      date: formatDate,
                    }"
                    :headers="headerInfo"
                    :limit="1"
                    :on-exceed="handleExceed"
                    :on-success="handleSuccess"
                    :before-upload="beforeUpload"
                    :file-list="fileList"
                    :auto-upload="false"
                  >
                    <i class="el-icon-upload"></i>
                    <div class="el-upload__text">
                      {{ $t('common_words.finished_format') }}
                      <em>{{ $t('common_words.click_to_load') }}</em>
                    </div>
                    <div slot="tip" class="el-upload__tip">
                      {{ $t('common_words.xlsx_notice') }}
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="text-center" v-if="isCreate()">
                <button
                  style="margin-right: 10px"
                  class="btn btn-info btn-fg"
                  @click.prevent="downloadFormat"
                >
                  <i class="fa fa-file-excel-o"></i>
                  {{ $t('common_words.download_file') }}
                </button>
                <button
                  class="btn btn-info btn-fg"
                  @click.prevent="submitUpload"
                >
                  <i class="fa fa-plus"></i> {{ $t('common_words.load_file') }}
                </button>
              </div>
            </div>
          </div>
        </form>
        <br />
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header custom-table-responsive"
        v-if="cutting"
        :title="$t('production.cluster_fruit_croped')"
      >
        <div class="mt-4">
          <div class="row" v-if="isIndex() && (isCreate() || isUpdate())">
            <div class="table-responsive">
              <table
                aria-describedby="tabla-cosechados"
                class="table table-striped table-bordered"
                v-if="totalXweeks.length > 0 && lotsData.length > 0"
              >
                <thead>
                  <tr class="cusmtom-thead-color">
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '200px' }"
                    >
                      <strong>{{ $t('common_words.allotment') }}</strong>
                    </th>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '75px' }"
                    >
                      <strong>{{ $t('production.crew_division') }}</strong>
                    </th>
                    <th
                      scope="col"
                      class="text-center p-3 custom-header-label"
                      v-bind:style="{ minWidth: '160px' }"
                    >
                      <strong>{{ $t('common_words.area_roamed') }}</strong>
                    </th>
                    <th
                      v-for="(column, index) in avaliableTotals"
                      :key="index"
                      v-bind:style="{
                        backgroundColor: column.color,
                        color: column.colorText,

                        width: '120px',
                      }"
                      scope="col"
                      class="text-center"
                    >
                      <strong>{{ column.name }}</strong>
                    </th>
                    <th
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '90px' }"
                    >
                      <strong>{{ $t('common_words.total') }}</strong>
                    </th>
                    <th
                      v-if="!messageAlert"
                      scope="col"
                      class="text-center custom-header-label"
                      v-bind:style="{ width: '100px', marginTop: '6px' }"
                    >
                      <strong>{{ $t('common_words.options') }}</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(lot, i) in cuttingForm.nCutting" :key="i">
                    <td class="text-center">
                      <el-select
                        clearable
                        filterable
                        width="10"
                        class="select-primary custom-width-select required-lots shadow-sm"
                        size="medium"
                        v-model="cuttingForm.lots_sel[i]"
                        :placeholder="`${$t('common_words.select')}...`"
                        @change="onSelectLot($event, i)"
                        @clear="cleanLineFields('cleanRejectionLine')"
                      >
                        <el-option
                          v-for="l in lots"
                          class="select-primary"
                          :value="l.id"
                          :label="l.name"
                          :key="l.id"
                        ></el-option>
                      </el-select>
                    </td>
                    <td class="text-center">
                      <el-input
                        type="number"
                        min="0"
                        clearable
                        maxlength="4"
                        class="text-center input-gang"
                        @change="updateGangLotsData($event, i)"
                        v-model="cuttingForm.gang[i]"
                      >
                      </el-input>
                    </td>
                    <td class="text-center">
                      <el-input
                        type="number"
                        clearable
                        min="0"
                        maxlength="4"
                        step="0.1"
                        class="text-center input-covered_area"
                        @change="updateAreaLotsData($event, i)"
                        v-model="cuttingForm.covered_area[i]"
                      >
                        <template slot="append">(ha)</template>
                      </el-input>
                    </td>
                    <td
                      class="text-center"
                      v-for="(m, j) in avaliableRibbons"
                      :key="j"
                    >
                      <el-input
                        clearable
                        @change="updateLotsData(i, j, $event)"
                        maxlength="4"
                        class="text-center"
                        v-model="lotsData[i]['weeks'][j].value"
                      />
                    </td>
                    <td class="text-muted text-center" style="font-size: 15px">
                      {{ lotsData[i]['total'] }}
                    </td>
                    <td
                      v-if="!messageAlert"
                      class="text-center"
                      style="display: table-cell"
                      v-bind:style="{ width: '100px' }"
                    >
                      <div class="d-flex justify-content-center mt-3">
                        <a
                          v-if="isUpdate()"
                          v-tooltip.top-center="$t('common_words.add')"
                          class="btn-warning btn-simple btn-link custom-margin-actions"
                          @click.prevent="addLotData()"
                        >
                          <em class="fa fa-plus custom-size-fa-actions"></em>
                        </a>
                        <a
                          v-if="cuttingForm.nCutting > 1 && isDelete()"
                          v-tooltip.top-center="$t('common_words.erase')"
                          class="btn-danger btn-simple btn-link custom-margin-actions"
                          @click="handleDelete(i)"
                        >
                          <em class="fa fa-times custom-size-fa-actions"></em>
                        </a>
                      </div>
                    </td>
                  </tr>
                  <tr class="text-center">
                    <td colspan="3" class="text-muted text-center">
                      <strong>{{ $t('common_words.total_mayus') }}</strong>
                    </td>
                    <td
                      class="text-muted text-center"
                      style="font-size: 15px"
                      v-for="(week, index) in avaliableTotals"
                      :key="index"
                    >
                      {{ week['total'] }}
                    </td>
                    <td>{{ totalGeneral }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateForm()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteAll()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <div v-if="messageAlert" class="alert alert-warning" role="alert">
        {{ messageAlert }}
      </div>
      <card
        class="custom-shadow-card-header"
        v-if="cutting"
        :title="$t('production.cluster_fruit_rejected')"
      >
        <div class="mt-4">
          <div
            class="row"
            style="overflow-x: auto"
            v-if="isIndex() && (isCreate() || isUpdate())"
          >
            <table
              style="width: 100%; white-space: nowrap"
              aria-describedby="tabla-recusados"
              class="table table-striped table-bordered"
              v-if="
                totalXRejectionsWeeks.length > 0 &&
                lotsRejectionsData.length > 0
              "
            >
              <thead>
                <tr class="cusmtom-thead-color">
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '220px' }"
                  >
                    <strong>{{ $t('common_words.allotment') }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center p-3 custom-header-label"
                    v-bind:style="{ minWidth: '220px' }"
                  >
                    <strong>{{ $t('production.motive_returned') }}</strong>
                  </th>
                  <th
                    v-for="(column, index) in avaliableRejectionsTotals"
                    :key="index"
                    v-bind:style="{
                      backgroundColor: column.color,
                      color: column.colorText,
                      height: '51px',
                    }"
                    scope="col"
                    class="text-center"
                  >
                    <strong>{{ column.name }}</strong>
                  </th>
                  <th
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '70px' }"
                  >
                    <strong>{{ $t('common_words.total') }}</strong>
                  </th>
                  <th
                    v-if="!messageAlert"
                    scope="col"
                    class="text-center custom-header-label"
                    v-bind:style="{ width: '100px', marginTop: '6px' }"
                  >
                    <strong>{{ $t('common_words.options') }}</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(lot, i) in rejectionsForm.nCuttingRejections"
                  :key="i"
                >
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-rejections-lots shadow-sm"
                      size="medium"
                      v-model="rejectionsForm.lots_rejections_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onSelectRejectionsChange($event, i, 'id')"
                    >
                      <el-option
                        v-for="l in availableRejectionsLots"
                        class="select-primary"
                        :value="l.id"
                        :label="l.name"
                        :key="l.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td class="text-center">
                    <el-select
                      clearable
                      filterable
                      class="select-primary custom-width-select required-rejections-reasons shadow-sm"
                      size="medium"
                      v-model="rejectionsForm.rejections_sel[i]"
                      :placeholder="`${$t('common_words.select')}...`"
                      @change="onSelectRejectionsChange($event, i, 'rejection')"
                    >
                      <el-option
                        v-for="r in rejections"
                        class="select-primary"
                        :value="r.id"
                        :label="r.name"
                        :key="r.id"
                      ></el-option>
                    </el-select>
                  </td>
                  <td
                    class="text-center"
                    v-for="(m, j) in avaliableRejectionsRibbons"
                    :key="j"
                  >
                    <el-input
                      clearable
                      @change="updateLotsRejectionsData(i, j, $event)"
                      maxlength="4"
                      class="text-center"
                      v-model="lotsRejectionsData[i]['weeks'][j].value"
                    />
                  </td>
                  <td class="text-muted text-center" style="font-size: 15px">
                    {{ lotsRejectionsData[i]['total'] }}
                  </td>
                  <td
                    v-if="!messageAlert"
                    class="text-center"
                    style="display: table-cell"
                    v-bind:style="{ width: '100px' }"
                  >
                    <div class="d-flex justify-content-center mt-3">
                      <a
                        v-if="isUpdate()"
                        v-tooltip.top-center="$t('common_words.add')"
                        class="btn-warning btn-simple btn-link custom-margin-actions"
                        @click.prevent="addLotRejectionsData()"
                      >
                        <em class="fa fa-plus custom-size-fa-actions"></em>
                      </a>
                      <a
                        v-if="
                          rejectionsForm.nCuttingRejections > 1 && isDelete()
                        "
                        v-tooltip.top-center="$t('common_words.erase')"
                        class="btn-danger btn-simple btn-link custom-margin-actions"
                        @click="handleRejectionsDelete(i)"
                      >
                        <em class="fa fa-times custom-size-fa-actions"></em>
                      </a>
                    </div>
                  </td>
                </tr>
                <tr class="text-center">
                  <td colspan="2" class="text-muted text-center">
                    <strong>{{ $t('common_words.total_mayus') }}</strong>
                  </td>
                  <td
                    class="text-muted text-center"
                    style="font-size: 15px"
                    v-for="(week, index) in avaliableRejectionsTotals"
                    :key="index"
                  >
                    {{ week['total'] }}
                  </td>
                  <td>{{ totalGeneralRejections }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else>
            <br />
            <h5 class="text-muted text-center">
              {{ $t('common_words.no_permissions_module') }}
            </h5>
          </div>
          <div v-if="!messageAlert" class="row">
            <div class="col-6 text-right" v-if="isCreate() || isUpdate()">
              <l-button
                wide
                type="info"
                class="btn-filter m-4"
                v-on:click="validateRejectionsForm()"
              >
                {{ $t('common_words.save') }}
              </l-button>
            </div>
            <div class="col-6 text-left" v-if="isDelete()">
              <l-button
                wide
                type="danger"
                class="btn-filter m-4"
                @click="deleteRejectionsAll()"
              >
                {{ $t('common_words.delete') }}
              </l-button>
            </div>
          </div>
        </div>
      </card>
      <div v-if="!messageAlert" class="row">
        <div
          class="col-12 text-center"
          v-if="cutting && (isCreate() || isUpdate())"
        >
          <l-button
            wide
            type="info"
            class="btn-filter m-4"
            v-on:click="validateAll()"
          >
            {{ $t('common_words.save_all') }}
          </l-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { getRepeatsFromArray } from 'src/util/Util.js';
import { getSumOfValorFromArray } from 'src/util/Util.js';
import { mapActions } from 'vuex';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  mixins: [
    MixinPermissions,
    mixinMasters,
    MixinMenu,
    MixinExport,
    MixinNotification,
  ],
  // components: {
  //   [AdminPermissions.name]: AdminPermissions,
  // },
  data() {
    return {
      cuttingForm: {
        totalArea: 0,
        calendar_sel: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        farm_id: null,
        forDelete: [],
        lots_sel: [],
        gang: [],
        covered_area: [],
        nCutting: 1,
        updating: false,
        user_id: this.$store.state.auth.user.id,
      },
      rejectionsForm: {
        calendar_sel: null,
        date_sel: new Date(moment().format('YYYY-MM-DD').replace(/-/, '/')),
        farm_id: null,
        forRejectionsDelete: [],
        lots_rejections_sel: [],
        rejections_sel: [],
        nCuttingRejections: 1,
        updating: false,
        user_id: this.$store.state.auth.user.id,
      },
      lotsData: [
        {
          id: null,
          gang: 0,
          covered_area: 0,
          weeks: [
            { week: 8, value: null },
            { week: 9, value: null },
            { week: 10, value: null },
            { week: 11, value: null },
            { week: 12, value: null },
            { week: 13, value: null },
            { week: 14, value: null },
            { week: 15, value: null },
          ],
          total: 0,
        },
      ],
      lotsRejectionsData: [
        {
          id: null,
          weeks: [
            { week: 8, value: null },
            { week: 9, value: null },
            { week: 10, value: null },
            { week: 11, value: null },
            { week: 12, value: null },
            { week: 13, value: null },
            { week: 14, value: null },
            { week: 15, value: null },
          ],
          total: 0,
        },
      ],
      relationLotRejections: [],
      relationLotGangs: [],
      cutting: false,
      isCuttingSave: false,
      isRejectionSave: true,
      farms: [],
      isShowCalendar: false,
      lots: [],
      rejections: [],
      ribbons: [],
      totalXweeks: [],
      totalXRejectionsWeeks: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      isSaveAll: false,
      messageAlert: null,
      showPreload: false,
      headerInfo: {
        Authorization: 'Bearer ' + this.$store.state.auth.token,
      },
      fileList: [],
      ringingCatchAdmin: false,
      permissionsForm: {
        youths: false,
        bacotas: false,
      },
    };
  },
  computed: {
    calendars() {
      if (this.cuttingForm.farm_id) {
        let calendars = [];
        this.farms.forEach((element) => {
          if (element.id == this.cuttingForm.farm_id) {
            calendars = element.calendars;
          }
        });
        return calendars;
      } else {
        return [];
      }
    },

    availableLots() {
      return this.lots.filter(
        (lot) => !this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    availableRejectionsLots() {
      return this.lots.filter((lot) =>
        this.cuttingForm.lots_sel.includes(lot.id)
      );
    },

    totalGeneral() {
      let sum = 0;
      this.totalXweeks.forEach((week) => {
        sum = sum + week['total'];
      });
      return sum;
    },

    totalGeneralRejections() {
      let sum = 0;
      this.totalXRejectionsWeeks.forEach((week) => {
        sum = sum + week['total'];
      });
      return sum;
    },

    avaliableRibbons() {
      return this.totalXweeks.filter((element, index) => element.color != '')
        .length;
    },

    avaliableRejectionsRibbons() {
      return this.totalXRejectionsWeeks.filter(
        (element, index) => element.color != ''
      ).length;
    },

    avaliableTotals() {
      return this.totalXweeks.filter((element, index) => element.color != '');
    },

    avaliableRejectionsTotals() {
      return this.totalXRejectionsWeeks.filter(
        (element, index) => element.color != ''
      );
    },

    formatDate() {
      return moment(this.cuttingForm.date_sel).format('Y-MM-DD');
    },
  },
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    /**
     * Mostrar la notificación temporal
     */
    notification({ message, type, icon, title, position }) {
      this.showNotification(message, type, icon, title, position);
    },

    /**
     * Abrir el formulario de administrador de permisos
     */
    openAdminPermissions() {
      this.ringingCatchAdmin = true;
    },

    /**
     * Cerrar el formulario de administrador de permisos
     */
    closeAdminPermissions() {
      this.ringingCatchAdmin = false;
    },

    hideView() {
      this.cutting = false;
      this.showPreload = false;
    },

    preload() {
      this.cleanForm();
      this.cuttingForm.id = null;

      if (this.validateFilter()) {
        this.cutting = false;
        this.showPreload = true;
      }
    },

    validateFilter() {
      this.cuttingForm.id = null;

      if (this.cuttingForm.farm_id == null) {
        this.highlightItem('farm-form');

        return false;
      } else if (this.cuttingForm.date_sel == null) {
        this.highlightItem('date-form');

        return false;
      } else {
        return true;
      }
    },

    submitUpload() {
      this.$refs.upload.submit();
    },

    handleExceed(files, fileList) {
      SweetAlert.warning(
        `${i18n.t('sweet_alert.ground.selected_limit')} ${
          files.length
        } ${i18n.t('sweet_alert.ground.files')} `
      );
    },

    beforeUpload(file) {
      this.cuttingForm.date_sel = moment(this.cuttingForm.date_sel).format(
        'Y-MM-DD'
      );
    },

    handleSuccess(res, file) {
      const errors = Array.isArray(res.errors) ? res.errors : [];
      const data = Array.isArray(res.data) ? res.data : [];
      const message = typeof res.message === 'string' ? res.message : '';

      if (errors.length > 0) {
        let html = errors.map((e) => `<p>${e}</p>`).join('');
        if (message) html += `<hr/><p><strong>${message}</strong></p>`;

        SweetAlert.warning(html);
      } else if (data.length > 0) {
        let html = `<p><strong>${message}</strong></p>`;
        html += `<hr/><p>${i18n.t(
          'common_words.number_records_successfully'
        )}: ${data.length}</p>`;

        SweetAlert.success(html);
        this.cleanForm();
      } else {
        SweetAlert.info(i18n.t('common_words.no_new_data_was_recorded'));
      }

      this.cuttingForm.date_sel = new Date(
        moment().format('YYYY-MM-DD').replace(/-/, '/')
      );

      this.$refs.upload.clearFiles();
    },

    downloadFormat() {
      let self = this;
      let data = self.cuttingForm;
      data.route = 'cutting/cuts/preformat';
      data.name_file = 'precarga_cosecha.xlsx';
      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    showCalendar() {
      this.messageAlert = null;
      this.isShowCalendar = true;
      this.cuttingForm.calendar_sel = null;
      this.cutting = false;

      const element = Object.values(this.farms).find(
        (el) => el.id === this.cuttingForm.farm_id
      );
      if (element) {
        this.cuttingForm.totalArea = this.getTotalAreaFromFarm(
          this.farms,
          this.cuttingForm.farm_id
        );
        this.isShowCalendar = element.calendars.length > 1;
        this.cuttingForm.calendar_sel =
          element.calendars.length > 1
            ? null
            : element.calendars.length == 1
            ? element.calendars[0].id
            : null;
      }

      this.isShowCalendar = false;
    },

    cleanLineFields(option) {
      if (option === 'cleanRejectionLine') {
        this.rejectionsForm.lots_rejections_sel.forEach((lot, lotIndex) => {
          if (lot === null) {
            this.isRejectionSave = false;
            this.rejectionsForm.lots_rejections_sel[lotIndex] = null;
          }
        });
      }
    },

    onSelectLot(value, lot_index) {
      let error = this.relationLotGangs.includes(
        `${value} - ${this.cuttingForm.gang[lot_index]}`
      );

      this.relationLotGangs[lot_index] = `${value} - ${
        this.cuttingForm.gang[lot_index]
          ? this.cuttingForm.gang[lot_index]
          : `gang`
      }`;

      if (error) {
        SweetAlert.warning(
          i18n.t('common_words.sweet_alert.production.duplicated_error')
        );
      } else {
        this.relationLotRejections.forEach((element, i) => {
          if (element.includes(this.lotsData[lot_index]['id'] + ' - ')) {
            this.rejectionsForm.lots_rejections_sel[i] = null;
            element.replace(this.lotsData[lot_index]['id'] + ' - ', 'id - ');
          }
        });

        this.lotsData[lot_index]['gang'] = this.cuttingForm.gang[lot_index]
          ? this.cuttingForm.gang[lot_index]
          : 0;

        this.lotsData[lot_index]['covered_area'] = this.cuttingForm
          .covered_area[lot_index]
          ? this.cuttingForm.covered_area[lot_index]
          : 0;

        if (this.lotsData[lot_index]['id'] == null) {
          this.lotsData[lot_index]['id'] = value;
        } else {
          this.lotsData[lot_index]['id_replace'] = value;
        }

        const idDetail = this.lotsData[lot_index]['id_detail'];
        if (
          idDetail !== null &&
          idDetail !== '' &&
          this.cuttingForm.forDelete.includes(idDetail)
        ) {
          this.lotsData[lot_index]['id'] = value;
          this.cuttingForm.forDelete = this.cuttingForm.forDelete.filter(
            (element) => element != idDetail
          );
        }

        this.isCuttingSave = false;
      }
    },

    async updateGangLotsData(value, index) {
      if (parseInt(value) >= 0 && !isNaN(value)) {
        let error = await this.relationLotGangs.includes(
          `${this.cuttingForm.lots_sel[index]} - ${value}`
        );
        if (error) {
          SweetAlert.warning(
            `${i18n.t('sweet_alert.production.duplicated_error')} ${index + 1}.`
          );
          this.lotsData[index]['gang'] = 0;
        } else {
          this.lotsData[index]['gang'] = value;
        }
        if (this.lotsData[index] && this.lotsData[index]['id'])
          this.relationLotGangs[
            index
          ] = `${this.cuttingForm.lots_sel[index]} - ${value}`;
        else this.relationLotGangs[index] = `id - ${value}`;
      } else {
        this.$set(this.cuttingForm.gang, index, 0);
        this.lotsData[index]['gang'] = 0;
      }

      this.isCuttingSave = false;
    },

    updateAreaLotsData(value, index) {
      if (parseInt(value) >= 0 && !isNaN(value)) {
        this.lotsData[index]['covered_area'] = value;
      } else {
        this.$set(this.cuttingForm.covered_area, index, 0);
        this.lotsData[index]['covered_area'] = 0;
      }

      this.isCuttingSave = false;
    },

    onSelectRejectionsChange(value, index, field) {
      if (field === 'id') {
        const rlr = this.relationLotRejections[index];
        const newValue =
          value && (value == '' || value.length == 0) ? 'id' : value;

        if (rlr && rlr.includes('id - '))
          this.relationLotRejections[index] = rlr.replace('id', newValue);
        else {
          if (rlr && rlr.includes(' - rejection'))
            this.relationLotRejections[index] = newValue + ' - rejection';
          else {
            const splits = rlr ? rlr.split(' - ') : '';
            this.relationLotRejections[index] = splits[1]
              ? (newValue === '' ? 'id' : newValue) + ' - ' + splits[1]
              : newValue + ' - rejection';
          }
        }
      }

      if (field === 'rejection') {
        const rlr = this.relationLotRejections[index];
        const newValue =
          value && (value === '' || value.length === 0) ? 'rejection' : value;

        if (rlr && rlr.includes(' - rejection'))
          this.relationLotRejections[index] = rlr.replace(
            'rejection',
            newValue
          );
        else {
          if (rlr && rlr.includes('id - '))
            this.relationLotRejections[index] = 'id - ' + newValue;
          else {
            const splits = rlr ? rlr.split(' - ') : '';
            this.relationLotRejections[index] = splits[0]
              ? splits[0] + ' - ' + (newValue === '' ? 'rejection' : newValue)
              : 'id - ' + newValue;
          }
        }
      }

      if (this.lotsRejectionsData[index][field] == null) {
        this.lotsRejectionsData[index][field] = value;
      } else {
        this.lotsRejectionsData[index][field + '_replace'] = value;
      }

      const idDetail = this.lotsRejectionsData[index]['id_detail'];
      if (
        idDetail !== null &&
        idDetail !== '' &&
        this.rejectionsForm.forRejectionsDelete.includes(idDetail)
      ) {
        this.lotsRejectionsData[index][field] = value;
        this.rejectionsForm.forRejectionsDelete =
          this.rejectionsForm.forRejectionsDelete.filter(
            (element) => element != idDetail
          );
      }

      this.isRejectionSave = false;
    },

    /**
     * Limpia la información referente a la finca
     */
    cleanFarm() {
      this.messageAlert = null;
      this.cuttingForm.farm_id = null;
      this.cuttingForm.totalArea = 0;
    },

    cleanForm(cleanAll = true) {
      this.isSaveAll = false;
      this.relationLotRejections = [];
      this.relationLotGangs = [];

      if (!this.cuttingForm.farm_id) {
        this.cuttingForm.totalArea = 0;
      }

      this.cuttingForm.lots_sel = [];
      this.cuttingForm.gang = [];
      this.cuttingForm.covered_area = [];
      this.cuttingForm.nCutting = 1;
      this.lotsData = [
        {
          id: null,
          gang: 0,
          covered_area: 0,
          weeks: [
            { week: 8, value: null, id_detail: null },
            { week: 9, value: null, id_detail: null },
            { week: 10, value: null, id_detail: null },
            { week: 11, value: null, id_detail: null },
            { week: 12, value: null, id_detail: null },
            { week: 13, value: null, id_detail: null },
            { week: 14, value: null, id_detail: null },
            { week: 15, value: null, id_detail: null },
          ],
          total: 0,
        },
      ];

      if (cleanAll) {
        this.totalXweeks = [];
        this.lots = [];
      }
    },

    cleanRejectionsForm(cleanAll = true) {
      this.isRejectionSave = true;
      this.rejectionsForm.updating = false;
      this.isSaveAll = false;
      this.relationLotRejections = [];
      this.rejectionsForm.lots_rejections_sel = [];
      this.rejectionsForm.rejections_sel = [];
      this.rejectionsForm.nCuttingRejections = 1;
      this.lotsRejectionsData = [
        {
          id: null,
          weeks: [
            { week: 8, value: null, id_detail: null },
            { week: 9, value: null, id_detail: null },
            { week: 10, value: null, id_detail: null },
            { week: 11, value: null, id_detail: null },
            { week: 12, value: null, id_detail: null },
            { week: 13, value: null, id_detail: null },
            { week: 14, value: null, id_detail: null },
            { week: 15, value: null, id_detail: null },
          ],
          total: 0,
        },
      ];

      if (cleanAll) {
        this.totalXRejectionsWeeks = [];
        this.rejections = [];
      }
    },

    validate() {
      if (this.cuttingForm.farm_id == null) {
        return this.validationInputsRequired('arm');
      } else if (this.cuttingForm.date_sel == null) {
        return this.validationInputsRequired('date');
      } else if (this.cuttingForm.calendar_sel == null) {
        SweetAlert.warning(i18n.t('common_words.no_associated_calendars'));
      } else {
        this.messageAlert = null;
        this.cleanForm();
        this.loadCuttings();
        this.cuttingForm.totalArea = this.getTotalAreaFromFarm(
          this.farms,
          this.cuttingForm.farm_id
        );
      }
    },

    validateAll() {
      this.isSaveAll = true;
      this.validateForm();
    },

    validateForm() {
      const msgLot = i18n.t('message.production.select_allotment');
      const msgNotUnique = `${i18n.t(
        'sweet_alert.production.duplicated_error'
      )} `;
      const msgWeeks = `${i18n.t('message.production.missing_fields')}`;

      if (this.cuttingForm.nCutting != this.cuttingForm.lots_sel.length) {
        SweetAlert.warning(msgLot);
        return this.validationInputsRequired('lots');
      } else {
        if (
          getSumOfValorFromArray(this.cuttingForm.covered_area) >
          this.cuttingForm.totalArea
        ) {
          SweetAlert.warning(
            `${i18n.t('sweet_alert.production.wrong_area')}"${Number(
              this.cuttingForm.totalArea
            ).toFixed(2)}(ha)", ${i18n.t('sweet_alert.production.cannot_save')}`
          );
        } else {
          this.validateLinesTotalArea()
            .then(() => {
              return this.validateLinesCutting()
                .then(() => {
                  this.saveCutting();
                })
                .catch((error) => {
                  console.log(error);
                  this.isSaveAll = false;

                  switch (error) {
                    case -1:
                      SweetAlert.warning(msgLot);
                      break;

                    case -2:
                      SweetAlert.warning(`${msgNotUnique} ${error * -1}.`);
                      break;

                    default:
                      SweetAlert.warning(`${msgWeeks} ${error + 1}`);
                      break;
                  }
                });
            })
            .catch((error) =>
              SweetAlert.warning(
                `${i18n.t('sweet_alert.production.digited_area')}${
                  error[0] + 1
                }, ${i18n.t('sweet_alert.production.cannot_be_greater_than')}"${
                  error[1]
                }(ha)", ${i18n.t('sweet_alert.production.check_info')}`
              )
            );
        }
      }
    },

    /**
     * Verifica si existen datos escritos en la tabla de
     * recusados para el guardado
     */
    checkIfThereNotDataInRejectionsTable() {
      const isEmptyRejectionLots =
        this.rejectionsForm.lots_rejections_sel.filter(
          (lot) => lot !== null && lot !== ''
        ).length === 0;
      const isEmptyRejection =
        this.rejectionsForm.rejections_sel.filter(
          (rejection) => rejection !== null && rejection !== ''
        ).length === 0;

      let isEmptyWeeks = true;
      this.lotsRejectionsData.forEach((_, i) => {
        this.lotsRejectionsData[i]['weeks'].forEach((_, j) => {
          if (
            this.lotsRejectionsData[i]['weeks'][j]['value'] !== null &&
            Number.isInteger(
              parseInt(this.lotsRejectionsData[i]['weeks'][j]['value'])
            )
          ) {
            isEmptyWeeks = false;
          }
        });
      });

      return isEmptyRejectionLots && isEmptyRejection && isEmptyWeeks;
    },

    validateRejectionsForm(checkDataInRejectionsTable = false) {
      this.validateLinesTotalArea()
        .then(() => {
          return this.validateLinesCutting()
            .then(() => {
              const msgLot = i18n.t('message.production.info_allotment');
              const msgRejection = i18n.t('message.production.info_rejected');
              const msgNotUnique = i18n.t(
                'message.production.allotment_rejected'
              );
              const msgNotChange = i18n.t('message.production.pending_changes');
              const msgNotSave = i18n.t('message.production.save_crop');

              if (
                checkDataInRejectionsTable &&
                this.checkIfThereNotDataInRejectionsTable()
              ) {
                this.cleanForm();
                this.cleanRejectionsForm();
                this.cutting = false;
                this.isCuttingSave = false;
                this.showHideLoading();
              } else {
                if (
                  this.rejectionsForm.nCuttingRejections !=
                  this.rejectionsForm.lots_rejections_sel.filter(
                    (lot) => lot !== null && lot !== ''
                  ).length
                ) {
                  SweetAlert.warning(msgLot);
                  return this.validationInputsRequired('rejections-lots');
                } else {
                  if (
                    this.rejectionsForm.nCuttingRejections !=
                    this.rejectionsForm.rejections_sel.filter(
                      (reject) => reject !== null && reject !== ''
                    ).length
                  ) {
                    SweetAlert.warning(msgRejection);
                    return this.validationInputsRequired('rejections-reasons');
                  } else {
                    if (
                      getRepeatsFromArray(this.relationLotRejections).length > 0
                    ) {
                      SweetAlert.warning(msgNotUnique);
                    } else {
                      if (!this.isCuttingSave && this.cuttingForm.updating) {
                        SweetAlert.warning(msgNotChange);
                      } else {
                        return this.validateLinesRejections()
                          .then(() => {
                            if (
                              !this.isCuttingSave &&
                              !this.cuttingForm.updating
                            )
                              SweetAlert.warning(msgNotSave);
                            else this.saveRejections();
                          })
                          .catch((error) => {
                            this.isSaveAll = false;
                            this.showMessageValidationsRejections(
                              error,
                              'rejection'
                            );
                          });
                      }
                    }
                  }
                }
              }
            })
            .catch((error) => {
              this.showMessageValidationsRejections(error, 'cutting');
            });
        })
        .catch((error) =>
          SweetAlert.warning(
            `${i18n.t('sweet_alert.production.digited_area')}${
              error[0] + 1
            }, ${i18n.t('sweet_alert.production.cannot_be_greater_than')}"${
              error[1]
            }(ha)", ${i18n.t('sweet_alert.production.check_info')}`
          )
        );
    },

    showMessageValidationsRejections(error, type = 'cutting') {
      let msgOne = '';
      let msgTwo = '';
      let msgThree = '';

      if (type === 'cutting') {
        msgOne = i18n.t('message.production.missing_allotment_info');
        msgTwo = `${i18n.t('message.production.duplicated_error')} ${
          error * -1
        }.`;
        msgThree = `${i18n.t('message.production.missing_crop_info')} `;
      } else {
        msgOne = i18n.t('message.production.missing_allotment_table_info');
        msgTwo = i18n.t('message.production.missing_rejected_info');
        msgThree = `${i18n.t(
          'message.production.missing_inputed_rejected_info'
        )}`;
      }

      switch (error) {
        case -1:
          SweetAlert.warning(msgOne);
          break;

        case -2:
          SweetAlert.warning(msgTwo);
          break;

        default:
          SweetAlert.warning(`${msgThree} ${error + 1}`);
          break;
      }
    },

    /**
     * Validar cada línea que el área digitada
     * por lote no pase el área permitida
     */
    async validateLinesTotalArea() {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.lotsData.length; i++) {
          const lotArea = this.getAreaFromLot(
            this.farms,
            this.cuttingForm.farm_id,
            this.lotsData[i]['id_replace']
              ? this.lotsData[i]['id_replace']
              : this.lotsData[i]['id']
          );
          if (Number(this.lotsData[i]['covered_area']) > Number(lotArea))
            reject([i, Number(lotArea).toFixed(2)]);
        }
        resolve();
      });
    },

    async validateLinesCutting() {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.lotsData.length; i++) {
          if (
            this.cuttingForm.lots_sel[i] === undefined ||
            this.cuttingForm.lots_sel[i] === ''
          ) {
            this.validationInputsRequired('lots');
            reject(-1);
          }

          this.relationLotGangs = [];
          this.cuttingForm.lots_sel.forEach((lot, i) => {
            this.relationLotGangs[i] = `${lot} - ${
              this.cuttingForm.gang[i] ? this.cuttingForm.gang[i] : 0
            }`;
          });

          if (getRepeatsFromArray(this.relationLotGangs).length > 0) reject(-2);

          let band = false;
          for (let j = 0; j < this.lotsData[i]['weeks'].length; j++) {
            if (this.lotsData[i]['weeks'][j]['value'] !== null) {
              band = true;
              if (
                Number.isInteger(
                  parseInt(this.lotsData[i]['weeks'][j]['value'])
                )
              )
                break;
            }

            if (this.lotsData[i]['weeks'][j]['value'] === '') {
              band = false;
            }
          }
          if (!band) {
            reject(i);
          }
        }
        resolve();
      });
    },

    async validateLinesRejections() {
      return new Promise((resolve, reject) => {
        for (let i = 0; i < this.lotsRejectionsData.length; i++) {
          if (
            this.rejectionsForm.lots_rejections_sel[i] === undefined ||
            this.rejectionsForm.lots_rejections_sel[i] === ''
          ) {
            this.validationInputsRequired('rejections-lots');
            reject(-1);
          }

          if (
            this.rejectionsForm.rejections_sel[i] === undefined ||
            this.rejectionsForm.rejections_sel[i] === ''
          ) {
            this.validationInputsRequired('rejections-reasons');
            reject(-2);
          }

          let band = false;
          for (let j = 0; j < this.lotsRejectionsData[i]['weeks'].length; j++) {
            if (this.lotsRejectionsData[i]['weeks'][j]['value'] !== null) {
              band = true;
              if (
                Number.isInteger(
                  parseInt(this.lotsRejectionsData[i]['weeks'][j]['value'])
                )
              )
                break;
            }

            if (this.lotsRejectionsData[i]['weeks'][j]['value'] === '') {
              band = false;
            }
          }
          if (!band) {
            reject(i);
          }
        }
        resolve();
      });
    },

    updateLotsData(lot_index, week_index, $event) {
      if (!isNaN($event)) {
        let total = 0;
        let totalWeek = 0;
        this.lotsData[lot_index]['weeks'].forEach((item) => {
          if (item.value != null && item.value != '' && item.value != '0') {
            total = total + Number.parseInt(item.value);
          }
        });
        this.lotsData[lot_index]['total'] = total;

        for (let i = 0; i < this.lotsData.length; i = i + 1) {
          for (let j = 0; j < this.lotsData[i]['weeks'].length; j = j + 1) {
            if (j == week_index) {
              if (
                this.lotsData[i]['weeks'][j]['value'] != null &&
                this.lotsData[i]['weeks'][j]['value'] != ''
              ) {
                totalWeek =
                  totalWeek +
                  Number.parseInt(this.lotsData[i]['weeks'][j]['value']);
              }
            }
          }
        }
        this.totalXweeks[week_index]['total'] = totalWeek;
        this.isCuttingSave = false;
      } else {
        this.totalXweeks[week_index]['total'] = 0;
        this.lotsData[lot_index]['weeks'][week_index]['value'] = null;
        this.isCuttingSave = false;
      }
    },

    updateLotsRejectionsData(lot_index, week_index, $event) {
      if (!isNaN($event)) {
        let total = 0;
        let totalWeek = 0;
        this.lotsRejectionsData[lot_index]['weeks'].forEach((item) => {
          if (item.value != null && item.value != '' && item.value != '0') {
            total = total + Number.parseInt(item.value);
          }
        });
        this.lotsRejectionsData[lot_index]['total'] = total;

        for (let i = 0; i < this.lotsRejectionsData.length; i = i + 1) {
          for (
            let j = 0;
            j < this.lotsRejectionsData[i]['weeks'].length;
            j = j + 1
          ) {
            if (j == week_index) {
              if (
                this.lotsRejectionsData[i]['weeks'][j]['value'] != null &&
                this.lotsRejectionsData[i]['weeks'][j]['value'] != ''
              ) {
                totalWeek =
                  totalWeek +
                  Number.parseInt(
                    this.lotsRejectionsData[i]['weeks'][j]['value']
                  );
              }
            }
          }
        }
        this.totalXRejectionsWeeks[week_index]['total'] = totalWeek;
        this.isRejectionSave = false;
      } else {
        this.totalXRejectionsWeeks[week_index]['total'] = 0;
        this.lotsRejectionsData[lot_index]['weeks'][week_index]['value'] = null;
        this.isRejectionSave = false;
      }
    },

    generateColumnData() {
      for (let i = 8; i <= 15; i = i + 1) {
        this.totalXweeks.push({
          name: `${i} ${i18n.t('common_words.week_short')}.`,
          total: 0,
          color: '',
          colorText: '',
          ribbon_id: null,
        });
      }
    },

    generateColumnRejectionsData() {
      for (let i = 8; i <= 15; i = i + 1) {
        this.totalXRejectionsWeeks.push({
          name: `${i} ${i18n.t('common_words.week_short')}`,
          total: 0,
          color: '',
          colorText: '',
          ribbon_id: null,
        });
      }
    },

    addLotData() {
      this.lotsData.push({
        id: null,
        gang: 0,
        covered_area: 0,
        weeks: [
          { week: 8, value: null, id_detail: null },
          { week: 9, value: null, id_detail: null },
          { week: 10, value: null, id_detail: null },
          { week: 11, value: null, id_detail: null },
          { week: 12, value: null, id_detail: null },
          { week: 13, value: null, id_detail: null },
          { week: 14, value: null, id_detail: null },
          { week: 15, value: null, id_detail: null },
        ],
        total: 0,
      });
      this.cuttingForm.nCutting++;
    },

    addLotRejectionsData() {
      this.lotsRejectionsData.push({
        id: null,
        weeks: [
          { week: 8, value: null, id_detail: null },
          { week: 9, value: null, id_detail: null },
          { week: 10, value: null, id_detail: null },
          { week: 11, value: null, id_detail: null },
          { week: 12, value: null, id_detail: null },
          { week: 13, value: null, id_detail: null },
          { week: 14, value: null, id_detail: null },
          { week: 15, value: null, id_detail: null },
        ],
        total: 0,
      });
      this.rejectionsForm.nCuttingRejections++;
    },

    handleDelete(lot_index) {
      this.cuttingForm.nCutting--;
      const toDelete = this.lotsData[lot_index]['id'];
      let toReplace = this.lotsData[lot_index]['id_replace'];

      const nLotsRepeats = this.cuttingForm.lots_sel.filter(
        (lot) => lot === toDelete
      ).length;

      this.lotsData[lot_index]['weeks'].forEach((week) => {
        const idDetail = week['id_detail'];
        if (idDetail !== null && idDetail !== '')
          this.cuttingForm.forDelete.push(idDetail);
      });

      if (toReplace === undefined) toReplace = toDelete;

      delete this.relationLotGangs[lot_index];
      this.cuttingForm.gang[lot_index] = 0;

      if (nLotsRepeats === 1) {
        this.relationLotRejections.forEach((element, i) => {
          if (element.includes(toReplace + ' - ')) {
            this.rejectionsForm.lots_rejections_sel[i] = null;
            element.replace(toReplace + ' - ', 'id - ');
          }
        });
      }

      this.lotsData.splice(lot_index, 1);

      try {
        let tmp = Object.assign([], this.cuttingForm.lots_sel);
        tmp.splice(lot_index, 1);
        setTimeout(() => {
          this.cuttingForm.lots_sel = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      try {
        this.cuttingForm.gang.splice(lot_index, 1);
        let tmp = Object.assign([], this.cuttingForm.gang);
        this.cuttingForm.gang = [];
        setTimeout(() => {
          this.cuttingForm.gang = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      try {
        this.cuttingForm.covered_area.splice(lot_index, 1);
        let tmp = Object.assign([], this.cuttingForm.covered_area);
        this.cuttingForm.covered_area = [];
        setTimeout(() => {
          this.cuttingForm.covered_area = Object.assign([], tmp);
        }, 5);
      } catch (error) {}

      this.totalXweeks.forEach((_, i) => (this.totalXweeks[i]['total'] = 0));

      this.lotsData.forEach((_, i) => {
        this.totalXweeks.forEach((_, j) => {
          if (
            this.lotsData[i]['weeks'][j]['week'] ==
            this.totalXweeks[j]['name'].replace(
              `${i18n.t('common_words.week_short')}.`,
              ''
            )
          ) {
            const newValue = parseInt(this.lotsData[i]['weeks'][j]['value'])
              ? parseInt(this.lotsData[i]['weeks'][j]['value'])
              : 0;
            this.totalXweeks[j]['total'] = this.totalXweeks[j]['total']
              ? parseInt(this.totalXweeks[j]['total']) + newValue
              : newValue;
          }
        });
      });

      if (nLotsRepeats === 1) {
        this.showHideLoading(true);
        this.rejectionsDeleteByDeleteCutting();
      }
      this.isCuttingSave = false;
    },

    rejectionsDeleteByDeleteCutting() {
      let index = 0;
      for (const lot of this.rejectionsForm.lots_rejections_sel) {
        if (lot === null || lot === '') {
          this.handleRejectionsDelete(index);
          break;
        }
        index++;
      }

      setTimeout(() => {
        if (index < this.rejectionsForm.lots_rejections_sel.length)
          this.rejectionsDeleteByDeleteCutting();
        else {
          if (this.rejectionsForm.nCuttingRejections == 0)
            this.cleanRejectionsForm(false);
          this.showHideLoading();
        }
      }, 100);
    },

    handleRejectionsDelete(lot_index) {
      this.rejectionsForm.nCuttingRejections--;
      const toDelete = this.lotsRejectionsData[lot_index]['id'];
      let toReplace = this.lotsRejectionsData[lot_index]['id_replace'];

      this.lotsRejectionsData[lot_index]['weeks'].forEach((week) => {
        const idDetail = week['id_detail'];
        if (idDetail !== null && idDetail !== '')
          this.rejectionsForm.forRejectionsDelete.push(idDetail);
      });

      if (toReplace === undefined) toReplace = toDelete;

      this.lotsRejectionsData.splice(lot_index, 1);

      try {
        this.rejectionsForm.lots_rejections_sel.splice(lot_index, 1);
        this.rejectionsForm.rejections_sel.splice(lot_index, 1);
        this.relationLotRejections.splice(lot_index, 1);

        let tmp = Object.assign([], this.rejectionsForm.lots_rejections_sel);
        let tmp_rejections = Object.assign(
          [],
          this.rejectionsForm.rejections_sel
        );
        let tmp_relation = Object.assign([], this.relationLotRejections);

        this.rejectionsForm.lots_rejections_sel = [];
        this.rejectionsForm.rejections_sel = [];
        this.relationLotRejections = [];

        setTimeout(() => {
          this.rejectionsForm.lots_rejections_sel = Object.assign([], tmp);
          this.rejectionsForm.rejections_sel = Object.assign(
            [],
            tmp_rejections
          );
          this.relationLotRejections = Object.assign([], tmp_relation);
        }, 5);
      } catch (error) {}

      this.totalXRejectionsWeeks.forEach(
        (_, i) => (this.totalXRejectionsWeeks[i]['total'] = 0)
      );

      this.lotsRejectionsData.forEach((_, i) => {
        this.totalXRejectionsWeeks.forEach((_, j) => {
          if (
            this.lotsRejectionsData[i]['weeks'][j]['week'] ==
            this.totalXRejectionsWeeks[j]['name'].replace(
              `${i18n.t('common_words.week_short')}.'`,
              ''
            )
          ) {
            const newValue = parseInt(
              this.lotsRejectionsData[i]['weeks'][j]['value']
            )
              ? parseInt(this.lotsRejectionsData[i]['weeks'][j]['value'])
              : 0;
            this.totalXRejectionsWeeks[j]['total'] = this.totalXRejectionsWeeks[
              j
            ]['total']
              ? parseInt(this.totalXRejectionsWeeks[j]['total']) + newValue
              : newValue;
          }
        });
      });

      this.isRejectionSave = false;
    },

    deleteAll() {
      let date = moment(this.cuttingForm.date_sel).format('Y-MM-DD');
      SweetAlert.delete(
        `${i18n.t('sweet_alert.production.harvest_of')} ${date}`
      ).then((result) => {
        if (result.value) {
          if (!this.cuttingForm.updating) {
            this.cleanForm(false);
            this.rejectionsForm.lots_rejections_sel = [];
            this.totalXweeks.forEach(
              (_, i) => (this.totalXweeks[i]['total'] = 0)
            );
          } else {
            this.lotsData.forEach((_, i) => {
              this.lotsData[i]['total'] = '';
              this.lotsData[i]['weeks'].forEach((_, j) => {
                this.totalXweeks[j]['total'] = '';
                this.lotsData[i]['weeks'][j]['value'] = '';
              });
            });
            this.saveCutting(true).then(() => this.deleteRejectionsAll('all'));
          }
        }
      });
    },

    deleteRejectionsAll(option = 'alert') {
      const deletes = () => {
        if (this.rejectionsForm.updating && option === 'all') {
          this.lotsRejectionsData.forEach((_, i) => {
            this.lotsRejectionsData[i]['total'] = '';
            this.lotsRejectionsData[i]['weeks'].forEach((_, j) => {
              this.totalXRejectionsWeeks[j]['total'] = '';
              this.lotsRejectionsData[i]['weeks'][j]['value'] = '';
            });
          });

          this.saveRejections(option === 'all');
        } else {
          this.cleanRejectionsForm(false);
          this.totalXRejectionsWeeks.forEach(
            (_, i) => (this.totalXRejectionsWeeks[i]['total'] = 0)
          );
        }
      };

      if (option === 'alert') {
        let date = moment(this.cuttingForm.date_sel).format('Y-MM-DD');
        SweetAlert.delete(
          `${i18n.t('production.denegations_of')} ${date}`
        ).then((result) => {
          if (result.value) {
            option = this.rejectionsForm.updating ? 'all' : option;
            deletes();
          }
        });
      } else deletes();
    },

    async saveCutting(comeDelete = false) {
      let data = {
        route: 'cutting',
        data: {
          cuttingForm: this.cuttingForm,
          lotsData: this.lotsData,
          totalXweeks: this.totalXweeks,
        },
      };
      this.showHideLoading(true);
      await Axios.postMasters(data)
        .then((response) => {
          this.showHideLoading();

          if (!comeDelete) {
            SweetAlert.success(response.data.message);
          }

          if (this.isSaveAll) {
            this.isCuttingSave = true;
            this.validateRejectionsForm(true);
          } else {
            const isEmptyRejections =
              this.checkIfThereNotDataInRejectionsTable();
            if (
              (!isEmptyRejections &&
                this.isRejectionSave &&
                this.rejectionsForm.updating) ||
              isEmptyRejections ||
              comeDelete
            ) {
              this.cleanForm();
              if (!comeDelete) this.cleanRejectionsForm();
              this.cutting = false;
              this.isCuttingSave = false;
            } else {
              this.showHideLoading();
              this.loadCuttings('cutting');
              SweetAlert.warning(
                i18n.t('sweet_alert.production.pending_changes')
              );
            }
          }
        })
        .catch((error) => {
          this.isSaveAll = false;
          this.showHideLoading();
          console.log(error);
          try {
            this.showMessageErrors(error);
          } catch (e) {
            //
          }
        });
    },

    async saveRejections(comeDelete = false) {
      this.rejectionsForm = {
        ...this.rejectionsForm,
        calendar_sel: this.cuttingForm.calendar_sel,
        date_sel: this.cuttingForm.date_sel,
        farm_id: this.cuttingForm.farm_id,
      };

      let data = {
        route: 'cutting/rejections',
        data: {
          rejectionsForm: this.rejectionsForm,
          lotsRejectionsData: this.lotsRejectionsData,
          totalXRejectionsWeeks: this.totalXRejectionsWeeks,
        },
      };
      this.showHideLoading(true);
      await Axios.postMasters(data)
        .then((response) => {
          let msg = this.isSaveAll
            ? 'El registro de cosecha se ha guardado correctamente.'
            : response.data.message;
          if (comeDelete) {
            msg = 'Los registros se han eliminado correctamente.';
          }

          SweetAlert.success(msg);

          this.cleanForm();
          this.cleanRejectionsForm();
          this.cutting = false;
          this.isCuttingSave = false;
          this.showHideLoading();
        })
        .catch((error) => {
          this.isSaveAll = false;
          this.showHideLoading();
          console.log('error');
          try {
            this.showMessageErrors(error);
          } catch (e) {
            //
          }
        });
    },

    setColors(responseRibbons) {
      for (let i = 0; i < responseRibbons['weekColors'].length; i++) {
        this.totalXweeks[i]['color'] =
          responseRibbons['weekColors'][i]['color_code'];
        this.totalXweeks[i]['colorText'] =
          responseRibbons['weekColors'][i]['color_text'];
        this.totalXweeks[i]['ribbon_id'] =
          responseRibbons['weekColors'][i]['id'];
        this.totalXweeks[i]['week'] = responseRibbons['weekColors'][i]['week'];

        this.totalXRejectionsWeeks[i]['color'] =
          responseRibbons['weekColors'][i]['color_code'];
        this.totalXRejectionsWeeks[i]['colorText'] =
          responseRibbons['weekColors'][i]['color_text'];
        this.totalXRejectionsWeeks[i]['ribbon_id'] =
          responseRibbons['weekColors'][i]['id'];
        this.totalXRejectionsWeeks[i]['week'] =
          responseRibbons['weekColors'][i]['week'];
      }
    },

    loadCuttings(toExecute = 'all') {
      this.showHideLoading(true);
      let date = moment(this.cuttingForm.date_sel).format('Y-M-D');
      const axiosRequests = [];

      switch (toExecute) {
        case 'cutting':
          this.generateColumnData();
          axiosRequests.push(
            Axios.getMasters(
              `cutting/ribbons/${date}/${this.cuttingForm.farm_id}/${this.cuttingForm.calendar_sel}`
            )
          );

          break;

        case 'rejection':
          this.cleanForm();
          this.cleanRejectionsForm();
          this.generateColumnRejectionsData();
          axiosRequests.push(Axios.getMasters(`rejecteds/causes`));

          break;

        default:
          this.cleanForm();
          this.cleanRejectionsForm();
          this.generateColumnData();
          this.generateColumnRejectionsData();

          axiosRequests.push(
            Axios.getMasters('farms/farms/lots/' + this.cuttingForm.farm_id)
          );
          axiosRequests.push(
            Axios.getMasters(
              `cutting/ribbons/${date}/${this.cuttingForm.farm_id}/${this.cuttingForm.calendar_sel}`
            )
          );
          axiosRequests.push(Axios.getMasters(`rejecteds/causes`));

          break;
      }

      Promise.all(axiosRequests)
        .then((responses) => {
          let responseLots = [];
          let responseRibbons = [];
          let rejectionControlReasons = [];

          responses.forEach((resp) => {
            switch (resp.config.url) {
              case 'auth/farms/farms/lots/' + this.cuttingForm.farm_id:
                responseLots = resp.data.data;

                if (toExecute === 'all') {
                  this.lots = responseLots;
                }
                break;

              case `auth/cutting/ribbons/${date}/${this.cuttingForm.farm_id}/${this.cuttingForm.calendar_sel}`:
                responseRibbons = resp;

                try {
                  this.messageAlert = responseRibbons.data.closing.message;
                } catch (error) {
                  this.messageAlert = null;
                }

                if (toExecute === 'all' || toExecute === 'cutting') {
                  if (responseRibbons.data['lotsDataPrev'].length > 0) {
                    this.cuttingForm.nCutting =
                      responseRibbons.data['lotsDataPrev'].length;
                    this.lotsData = responseRibbons.data['lotsDataPrev'];
                    this.totalXweeks = responseRibbons.data['totalXweeks'];
                    this.cuttingForm.updating = true;
                    this.isCuttingSave = true;

                    let copy = [];

                    responseRibbons.data['lotsDataPrev'].forEach((lotData) => {
                      this.cuttingForm.lots_sel.push(lotData['id']);
                      this.cuttingForm.gang.push(lotData['gang']);
                      this.cuttingForm.covered_area.push(
                        lotData['covered_area']
                      );

                      this.relationLotGangs.push(
                        `${lotData['id']} - ${lotData['gang']}`
                      );

                      copy.push(lotData['id']);
                    });

                    try {
                      this.cuttingForm.lots_sel = [];
                      setTimeout(() => {
                        this.cuttingForm.lots_sel = Object.assign([], copy);
                      }, 5);
                    } catch (error) {}
                  } else {
                    this.cuttingForm.updating = false;
                    this.isCuttingSave = false;
                  }

                  this.cutting = true;
                }

                if (toExecute === 'all' || toExecute === 'rejection') {
                  if (
                    responseRibbons.data['lotsRejectionsDataPrev'] &&
                    responseRibbons.data['lotsRejectionsDataPrev'].length > 0
                  ) {
                    this.rejectionsForm.nCuttingRejections =
                      responseRibbons.data['lotsRejectionsDataPrev'].length;
                    this.lotsRejectionsData =
                      responseRibbons.data['lotsRejectionsDataPrev'];
                    this.totalXRejectionsWeeks =
                      responseRibbons.data['totalXRejectionsWeeks'];
                    this.rejectionsForm.updating = true;
                    this.isRejectionSave = true;

                    let copy = [];
                    let copyRejections = [];
                    responseRibbons.data['lotsRejectionsDataPrev'].forEach(
                      (lotData) => {
                        this.rejectionsForm.lots_rejections_sel.push(
                          lotData['id']
                        );
                        this.rejectionsForm.rejections_sel.push(
                          lotData['rejection']
                        );

                        this.relationLotRejections.push(
                          `${lotData['id']} - ${lotData['rejection']}`
                        );

                        copy.push(lotData['id']);
                        copyRejections.push(lotData['rejection']);
                      }
                    );

                    try {
                      this.rejectionsForm.lots_rejections_sel = [];
                      this.rejectionsForm.rejections_sel = [];
                      setTimeout(() => {
                        this.rejectionsForm.lots_rejections_sel = Object.assign(
                          [],
                          copy
                        );
                        this.rejectionsForm.rejections_sel = Object.assign(
                          [],
                          copyRejections
                        );
                      }, 5);
                    } catch (error) {}
                  } else {
                    this.rejectionsForm.updating = false;
                    this.isRejectionSave = false;
                  }
                }

                this.setColors(responseRibbons.data);
                break;

              case `auth/rejecteds/causes`:
                rejectionControlReasons = resp.data.data;

                if (toExecute === 'all' || toExecute === 'rejection') {
                  this.rejections = rejectionControlReasons;
                }
                break;

              default:
                break;
            }
          });
          this.showPreload = false;
          this.showHideLoading();
        })
        .catch((error) => {
          this.isCuttingSave = false;
          this.isRejectionSave = true;
          this.showHideLoading();
          console.log(error);
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      this.isCuttingSave = false;
      this.isRejectionSave = true;
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = response.data.data;
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('cutting');
  },

  destroyed() {
    this.deselectedItemOnMenu('cutting');
  },
};
</script>
<style>
.card .table:not(.not-last-td) thead th:last-child {
  display: revert !important;
}

.table-journals td:empty {
  visibility: hidden;
}
.table-journals td:blank {
  visibility: hidden;
}

.align-buttons {
  margin-top: 30px;
}
</style>
